import { render, staticRenderFns } from "./UiButtonCustomize.vue?vue&type=template&id=826ca436&scoped=true"
import script from "./UiButtonCustomize.vue?vue&type=script&lang=js"
export * from "./UiButtonCustomize.vue?vue&type=script&lang=js"
import style0 from "./UiButtonCustomize.vue?vue&type=style&index=0&id=826ca436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826ca436",
  null
  
)

export default component.exports